export const environment = {
  production: true,
  keycloakConfig:{
      realm:  'grahak',
      clientId: 'nextgenapps-pv',
      url: 'https://qa.sso.tatamotors.com/auth',
      },
      APIUrl: '/nextgen-apps/iconnectusermgmtapi',
      baseUrl: 'https://dev-portal.pvnextgenappsqa.tatamotors.com/nextgen-apps/',
      apiBaseUri:"apiUrl",
      baseSecretkey:"RuQYEGRM76CKfaIii2U4qafZzGdIbvGAU2Z+mGOgl78=",
      multiLanguage:'./assets/i18n/',
      application:
        {
          name: 'NextGen Apps',
          version: 'Angular 17.0.8',
          environs:""
        }
  };